import CustomJSFunction from "@views/thinking-layout-editor/CustomJSFunction";

export function CreatorCustomJSFunction(): JSX.Element {
  return <CustomJSFunction />;
}
